<template>
  <div class="wrapper">
    <div class="container p-0">
      <div class="main">
        <div class="header">
          <div class="logo">
            <img src="../assets/theme/header.png">
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-2" style="padding-bottom: 150px;">
      <div class="main">
        <div class="content">
          <div class="r-content">
            <TodayResult />
            <div class="banner">
              <img src="../assets/banner/n1.png">
            </div>
            <HistoryResults />
          </div>

          <div class="l-content">
            <div class="l-bolck">
              <div class="banner banner-bottom">
                <img src="../assets/banner/n2.png">
              </div>
              <div class="banner banner-bottom mt-2">
                <img src="../assets/banner/n3.png">
              </div>
              <div class="banner banner-bottom mt-2">
                <img src="../assets/banner/n4.png">
              </div>
              <div class="banner banner-bottom mt-2">
                <img src="../assets/banner/n5.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="footer-inner">
        Copyright ©{{year}} - LAOSGOLDLOTTERY.COM
      </div>
    </div>
  </div>
</template>
<script>
import TodayResult from './components/TodayResult.vue'
import HistoryResults from './components/HistoryResults.vue'
import moment from "@/moment"

export default {
  components: {
    TodayResult,
    HistoryResults
  },
  computed: {
    year() {
      return moment().format("YYYY")
    }
  }
}
</script>
<style lang="scss">
body {
  margin: 0;
  padding: 0;
  background-color: #000000;
}

.banner {
  img {
    width: 100%;
    max-width: 100%;
  }
}

.wrapper {
  max-width: 1140px;
  padding: 5px 0 0 0;
  background-image: url('../assets/theme/bg.png');
  background-size: cover;
  background-color: #011C53;
  background-repeat: no-repeat;
  background-position: center bottom;
  margin-right: auto;
  margin-left: auto;
}

.header-space {
  height: 8px;
  margin-top: 5px;
  background-color: #FFF;
  // border-top: 6px solid #CE0202;
  // border-bottom: 6px solid #CE0202;
}

.footer {
  margin-top: 0px;
  border-top: 6px solid #FFF;

  .footer-inner {
    text-align: center;
    // background-color: #4B0203;
    padding: 15px;
    color: #FFF;
  }
}

.container {
  .main {
    width: 1050px;
    max-width: 100%;
    margin: 0 auto;

    .header {
      // height: 227px;
      // background-image: url('../assets/theme/hbg.png');
      background-repeat: no-repeat;
      background-position: center bottom;
      background-color: #FEFEFE;
      background-size: 100% 100%;
      align-items: center;
      display: flex;
      justify-content: flex-start;
      align-content: center;

      .logo {
        // padding-left: 40px;

        img {
          // height: 180px;
          width: 100%;
        }
      }
    }

    .content {
      display: flex;
      margin-top: 5px;
      flex-direction: row-reverse;

      .l-content {
        width: 440px;

        .l-bolck {
          margin-bottom: 10px;

          .banner {
            img {
              width: 100%;
              max-width: 100%;
            }
          }
        }
      }
      .r-content {
        width: calc(100% - 450px);
        margin-left: 10px;

        .banner {
          margin-bottom: 10px;
          img {
            width: 100%;
            max-width: 100%;
          }
        }
      }
    }

    .content-b {
      margin-right: -5px;
      margin-left: -5px;
      display: flex;

      .banner {
        width: 33.3%;
        padding: 5px;
        text-align: center;
        img {
          max-width: 100%;
          border: 1px solid #EEE;
        }
      }
    }
  }
}

@media only screen and (max-width:991px) {
  .container {
    .main {
      .header {
        // height: 150px;

        // .logo {
        //   padding-left: 20px;

        //   img {
        //     height: 130px;
        //   }
        // }
      }

      .content {
        flex-direction: column;

        .l-content {
          width: 100%;
        }

        .r-content {
          width: 100%;
          margin-left: 0;
        }
      }
    }
  }
}

@media only screen and (max-width:767px) {
  .container {
    .main {
      // .header {
      //   height: 120px;

      //   .logo {
      //     padding-left: 20px;

      //     img {
      //       height: 100px;
      //     }
      //   }
      // }
    }
  }
}

@media only screen and (max-width:575px) {
  .wrapper {
    padding: 0;
  }

  .container .main .content .l-content {
    padding: 0 5px;
  }

  .container .main .content .r-content {
    padding: 0 5px;
  }
}

@media only screen and (max-width:460px) {
  .container {
    .main {
      // .header {
      //   height: 100px;

      //   .logo {
      //     padding-left: 10px;

      //     img {
      //       height: 90px;
      //     }
      //   }
      // }
    }
  }
}

@media only screen and (max-width:399px) {
  .container {
    .main {
      // .header {
      //   height: 80px;

      //   .logo {
      //     padding-left: 10px;

      //     img {
      //       height: 70px;
      //     }
      //   }
      // }
    }
  }
}

@media only screen and (max-width:350px) {
  .container {
    .main {
      // .header {
      //   height: 70px;

      //   .logo {
      //     padding-left: 10px;

      //     img {
      //       height: 60px;
      //     }
      //   }
      // }
    }
  }

  .now-result .result-head h2 {
    font-size: 1.2rem;
  }

  .now-result .result-body .result-top h1 {
    font-size: 3.5rem;

    span {
      padding: 0 4px;
    }
  }

  .history-results .his-head-bg h2 {
    font-size: 1.2rem;
  }
}

// @media only screen and (max-width:900px) {
//   .container .main {
//     .header {
//       height: 120px;
//       background-size: cover;
//       background-position: right;

//       .logo {
//         height: auto;

//         img {
//           height: 100px;
//         }
//       }
//     }
//     .header-space {
//       margin-top: 5px;
//     }
//     .content {
//       display: block;
//       width: 750px;
//       margin: 10px auto 0;

//       .l-content {
//         width: 100%;

//         .banner-bottom {
//           display: none;
//         }
//       }
//       .r-content {
//         width: 100%;
//         margin-left: 0px;
//         margin-top: 15px;
//       }
//     }
//   }
// }

// @media only screen and (max-width:767px) {
//   .container .main {
//     .content {
//       width: 590px;
//     }
//   }
// }

// @media only screen and (max-width:600px) {
//   .container {
//     border-top: 8px solid blue;
//     .main {
//       .header {
//         height: 100px;
//         background-size: cover;
//         background-position: right;

//         .logo {
//           img {
//             height: 90px;
//           }
//         }
//       }
//       .content {
//         width: 490px;
//       }
//     }
//   }

//   .container .main .content-b {
//     display: block;
//     padding: 0 10px;
//     .banner {
//       width: 100%;
//     }
//   }
// }

// @media only screen and (max-width:500px) {
//   .container {
//     border-top: 5px solid blue;

//     .main {
//       .header {
//         height: 80px;
//         .logo {
//           padding-left: 10px;
//           img {
//             height: 70px;
//           }
//         }
//       }
//       .content {
//         width: 100%;
//         .r-content {
//           table.table {
//             font-size: 15px;
//           }
//         }
//       }
//     }
//   }
// }

// @media only screen and (max-width:400px) {
//   .container {
//     .main {
//       .header {
//         height: 60px;
//         .logo {
//           padding-left: 5px;
//           img {
//             height: 50px;
//           }
//         }
//       }
//     }
//   }
// }
</style>
